"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _images = require("../resources/images");

var fontFace = 'Helvetica';

var addHeaderContentSlide = function addHeaderContentSlide(presentation, _ref, content) {
  var title = _ref.title,
      subtitle = _ref.subtitle;
  presentation.withSlide(function (slide) {
    slide.withText(title, {
      fontFace: fontFace,
      fontSize: 18,
      h: 0.41,
      w: 7.97,
      x: 0.22,
      y: 0.22,
      bold: true
    }).withImage({
      data: _images.logoGreen,
      h: 0.2,
      w: 1.33,
      x: 8.45,
      y: 0.23
    });

    if (subtitle) {
      slide.withText(subtitle, {
        fontFace: fontFace,
        fontSize: 9,
        h: 0.23,
        w: 7.97,
        x: 0.22,
        y: 0.6
      });
    }

    return content(slide);
  });
};

var _default = addHeaderContentSlide;
exports.default = _default;
module.exports = exports.default;